<template>
  <div class="md-layout p-4">

    <div class="md-layout-item md-size-25 md-medium-size-33 md-large-size-25 md-small-size-50 md-xsmall-size-100" v-for="person in people.data">
    
      <div class="card card-video gradient-border-box bg-secondary illuminated-shadow-box m-2" :style="'background:url('+person.avatar+');background-size:cover;'">
          <div class="info-text  align-left">
            <h5 class="text-white pb-0 mb-0">España, {{person.age}} años</h5>
            <h3 class="text-white">{{person.name}}</h3>
          </div>
        <div class="info-box">
        </div>

        <iframe
          v-if="false"
          class="iframeyoutube"
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/47G9X8Bj21c?controls=1&autohide=1&showinfo=0&modestbranding=1&rel=0&fs=0"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
        ></iframe>

     <svg width="251.3" class="arrow6 effectsvideo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="0.0 0.0 436.3 436.3" zoomAndPan="magnify" style="fill: rgb(0, 0, 0);" original_string_length="687">
     <radialGradient xmlns:xlink="http://www.w3.org/1999/xlink" cx="218.151" cy="218.151" gradientUnits="userSpaceOnUse" id="__id1_skztasea4q" r="218.151" xlink:actuate="onLoad" xlink:show="other" xlink:type="simple"><stop offset="0" style="stop-color: rgb(13, 110, 253);"/><stop offset=".654" stop-opacity=".345" style="stop-color: rgb(56, 182, 255);"/><stop offset="1" stop-opacity="0" style="stop-color: rgb(92, 225, 230);"/></radialGradient>
     <circle cx="218.15" cy="218.15" r="218.15" style="fill: url(&quot;#__id1_skztasea4q&quot;);"/>
     </svg>
  
      <svg width="451.3" class="arrow5 effectsvideo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="0.0 0.0 436.3 436.3" zoomAndPan="magnify" style="fill: rgb(0, 0, 0);" original_string_length="687">
      <circle cx="218.15" cy="218.15" r="218.15" style="fill: url(&quot;#__id1_skztasea4q&quot;);"/>
      </svg>
  
<svg  class="arrow1 effectsvideo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="14" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="0.1 -0.1 251.3 24.9" width="251.3" zoomAndPan="magnify"><g id="change1_1"><path d="M40.8,24.8h7.1V-0.1h-7.1V24.8z M27.3,24.8h7.1V-0.1h-7.1V24.8z M13.7,24.8h7.1V-0.1h-7.1V24.8z M0.1,24.8 h7.1V-0.1H0.1V24.8z M54.4,24.8h7.1V-0.1h-7.1V24.8z M68,24.8h7.1V-0.1H68V24.8z M81.5,24.8h7.1V-0.1h-7.1V24.8z M95.1,24.8h7.1 V-0.1h-7.1V24.8z M108.7,24.8h7.1V-0.1h-7.1V24.8z M122.2,24.8h7.1V-0.1h-7.1V24.8z M135.8,24.8h7.1V-0.1h-7.1V24.8z M149.4,24.8 h7.1V-0.1h-7.1V24.8z M162.9,24.8h7.1V-0.1h-7.1V24.8z M176.5,24.8h7.1V-0.1h-7.1V24.8z M190.1,24.8h7.1V-0.1h-7.1V24.8z M203.6,24.8h7.1V-0.1h-7.1V24.8z M217.2,24.8h7.1V-0.1h-7.1V24.8z M230.8,24.8h7.1V-0.1h-7.1V24.8z M244.3-0.1v24.9h7.1V-0.1H244.3 z" fill="rgb(13, 110, 253)"/></g></svg>
 
<svg class="arrow2 effectsvideo" width="251.3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="7.5 -0.1 272.0 16.8" zoomAndPan="magnify" style="fill: rgb(0, 0, 0);" original_string_length="856"><g id="__id5_skztasea4q"><path d="M193.5-0.1l-18,16.8h11.3l18-16.8H193.5z M174.8-0.1l-18,16.8h11.3l18-16.8H174.8z M156.2-0.1l-18,16.8h11.3 l18-16.8H156.2z M137.5-0.1l-18,16.8h11.3l18-16.8H137.5z M118.9-0.1l-18,16.8h11.3l18-16.8H118.9z M100.2-0.1l-18,16.8h11.3 l18-16.8H100.2z M81.5-0.1l-18,16.8h11.3l18-16.8H81.5z M62.9-0.1l-18,16.8h11.3l18-16.8H62.9z M44.2-0.1l-18,16.8h11.3l18-16.8 H44.2z M25.5-0.1l-18,16.8h11.3l18-16.8H25.5z M212.2-0.1l-18,16.8h11.3l18-16.8H212.2z M230.8-0.1l-18,16.8h11.3l18-16.8H230.8z M249.5-0.1l-18,16.8h11.3l18-16.8H249.5z M268.2-0.1l-18,16.8h11.3l18-16.8H268.2z" style="fill: rgb(255,255,255);"/></g></svg>

<svg  class="arrow3 effectsvideo" width="251.3"  height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="6.4 0.1 285.2 72.0" zoomAndPan="magnify" style="fill: rgb(0, 0, 0);" original_string_length="419"><g id="__id0_skztasea4q"><path d="M243.3,0.1l-77.1,72h48.3l77.1-72H243.3z M163.4,0.1l-77.1,72h48.3l77.1-72H163.4z M83.5,0.1l-77.1,72h48.3 l77.1-72H83.5z" style="fill: rgb(13, 110, 253);"/></g></svg>

<svg class="arrow4 effectsvideo"  width="251.3"  height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="10.2 9.0 258.3 34.7" zoomAndPan="magnify" style="fill: rgb(0, 0, 0);" original_string_length="235"><g id="__id4_skztasea4q"><path d="M10.2,9v8.7l11.2,8.7L10.2,35v8.7l22.4-17.4L10.2,9z M31.6,9v8.7l11.2,8.7L31.6,35v8.7L54,26.3L31.6,9z M52.9,9v8.7l11.2,8.7L52.9,35v8.7l22.4-17.4L52.9,9z M74.4,9v8.7l11.2,8.7L74.4,35v8.7l22.4-17.4L74.4,9z M95.8,9v8.7l11.2,8.7 L95.8,35v8.7l22.4-17.4L95.8,9z M117.3,9v8.7l11.2,8.7L117.3,35v8.7l22.4-17.4L117.3,9z M138.8,9v8.7l11.2,8.7L138.8,35v8.7 l22.4-17.4L138.8,9z M160.2,9v8.7l11.2,8.7L160.2,35v8.7l22.4-17.4L160.2,9z M181.7,9v8.7l11.2,8.7L181.7,35v8.7l22.4-17.4L181.7,9z M203.2,9v8.7l11.2,8.7L203.2,35v8.7l22.4-17.4L203.2,9z M224.6,9v8.7l11.2,8.7L224.6,35v8.7l22.4-17.4L224.6,9z M246.1,9v8.7 l11.2,8.7L246.1,35v8.7l22.4-17.4L246.1,9z" style="fill: rgb(13, 110, 253);"/></g></svg>

<div class="effectsvideo stars">
  <md-icon class="text-warning">star</md-icon>
  <md-icon class="text-warning">star</md-icon>
  <md-icon class="text-warning">star</md-icon>
  <md-icon class="text-warning">star</md-icon>
  <md-icon class="text-warning">star</md-icon>
</div> 
<div class="effectsvideo trophy text-white">
  <md-icon class="text-white">military_tech</md-icon> <small>Crossfit</small>
</div> 
  
  <md-button class="md-button md-danger buttontop cursor-pointer">Comenzar</md-button>

      </div>
    </div>
 


  </div>
</template>

<script>
import { getIndividuals } from "@/pages/Individuals/actions";
import Swal from "sweetalert2";
import permissionsMixin from '@/mixins/permissionsMixin';
import { getProfileStablishmentsAction } from "@/pages/Stablishments/actions";

export default {
  mixins: [permissionsMixin],
  
  data() {
    return {
      people:[]
    };
  },
  mounted() {

  },
  created(){

  getIndividuals().then((result) => {
        this.people = result;
   });

  },
  methods: {
  }
};
</script>
<style scoped>
.md-layout {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.md-layout-item {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
}

.card-video {
overflow:hidden;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* Esto mantiene la relación 16:9 */
  position: relative;
  height: 504px;
    border-radius: 0;
}

iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.gradient-border-box {
  padding: 2px;
  border: 3px solid;
  border-image: linear-gradient(to right, #0d6efd, #2196f0) 1;
}
.illuminated-shadow-box {
  transition: box-shadow 0.3s ease; /* Efecto suave al pasar el mouse */
}

.illuminated-shadow-box:hover {
  box-shadow: 0 0 30px 10px rgba(13, 110, 253, 0.8), 0 0 40px 1px rgba(0, 188, 212, 0.6);
  /* Sombra iluminada al pasar el mouse */
}
.info-box{
      position: absolute;
    top: 0;
    left: 0;
    z-index: 90;
    width: 100%;
    height: 500px;
    background: #0000004f;
}
.info-text{
      position: absolute;
    z-index: 99;
    padding: 10px;
    top:20px;
}
.effectsvideo {
  position: absolute;
  transition: transform 0.5s ease, opacity 0.5s ease;
  z-index: 90;
}
.effectsvideo.arrow1{ /*  linea rayas blancas */
  top:10px;
  left:-60px;
}
.effectsvideo.arrow2{ /* linea azul inclindada */
  top:460px;
  left:-70px;
}
.effectsvideo.arrow6{ /* bola azul arriba izquierda */
  top:-130px;
  left:-130px;
}
.effectsvideo.arrow3{
  top:360px;
  right:-100px;
      -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}
.effectsvideo.arrow4{
  top:60px;
  right:-100px;
      -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}
.effectsvideo.arrow5{ /* bola azul abajo derecha */
  top:290px;
  left:-180px;
}
.effectsvideo.stars{
  top:425px;
  left:15px;
}
.effectsvideo.trophy{
  top:400px;
  left:15px;
}


/* Estilo inicial para la flecha */
.effectsvideo.arrow3 {
  top: 360px;
  right: -100px;
  transform: rotate(90deg);
}

.iframeyoutube{
  transform: translateX(-1000px); 
}

.card-video:hover .iframeyoutube {
  transform: translateX(-0); /* Desliza hacia abajo */
}

.buttontop{
      margin-top: 447px;
     transform:  translateX(-300px);
    transition: transform 0.5s ease;
}

/* Cuando se hace hover sobre la tarjeta */
.card-video:hover .arrow3 {
  transform: translateY(100px) rotate(90deg); /* Desliza hacia abajo */
  opacity: 0; /* Desaparece */
}

.card-video:hover .arrow1 {
  transform: translateX(-100px); /* Desliza hacia abajo */
  opacity: 0; /* Desaparece */
}
.card-video:hover .arrow2 {
  transform: translateX(-100px); /* Desliza hacia abajo */
  opacity: 0; /* Desaparece */
}
.card-video:hover .arrow4 {
  transform: translateY(-100px) rotate(90deg); 
  opacity: 0; /* Desaparece */
}
.card-video:hover .arrow5 {
  transform: translateY(100px) rotate(90deg); 
  opacity: 0; /* Desaparece */
}
.card-video:hover .arrow6 {
  transform: translateY(-100px) rotate(90deg); 
  opacity: 0; /* Desaparece */
}
.card-video:hover .stars {
  transform: translateX(-100px); 
  opacity: 0; /* Desaparece */
    transition: transform 5s ease, opacity 0.5s ease;

}
.card-video:hover .trophy {
  transform: translateX(-100px); 
  opacity: 0; /* Desaparece */
    transition: transform 5s ease, opacity 0.5s ease;

}
.card-video:hover .info-box {
  transform: translateX(-1000px); 
}
.card-video:hover .info-text {
  transform: translateY(-100px); 
    transition: transform 0.5s ease, opacity 0.5s ease;
}
.card-video:hover .buttontop{
  transform: translateX(0px); 
}
</style>
